module.exports = __webpack_public_path__ + "img/img6.502d60c9.svg";